"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dispatcher = void 0;
const utilities_1 = require("../../utilities");
const logging_1 = require("../logging");
class Dispatcher {
    constructor() {
        this._eventHandlers = {};
        this._commandHandlers = {};
        this._queryHandlers = {};
    }
    registerEventHandler(eventType, eventHandler) {
        if (!this._eventHandlers[eventType]) {
            this._eventHandlers[eventType] = [];
        }
        this._eventHandlers[eventType].push(eventHandler);
        return this;
    }
    handleEvent(event, execContext) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._eventHandlers[event.$type]) {
                for (let i = 0; i < this._eventHandlers[event.$type].length; i++) {
                    try {
                        const handler = this._eventHandlers[event.$type][i];
                        yield handler.handle(event, execContext);
                    }
                    catch (e) {
                        execContext.logger.error({
                            location: logging_1.LoggerLocationFormatter.error(Dispatcher.$type, Dispatcher._eventMethodName),
                            error: e
                        });
                    }
                }
            }
            else {
                execContext.logger.info({
                    location: logging_1.LoggerLocationFormatter.end(Dispatcher.$type, Dispatcher._eventMethodName),
                    message: `no handler found for event type: ${event.$type}`
                });
            }
            return utilities_1.NoResult.instance;
        });
    }
    registerCommandHandler(commandType, commandHandler) {
        this._commandHandlers[commandType] = commandHandler;
        return this;
    }
    handleCommand(command, execContext) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._commandHandlers[command.$type]) {
                const handlingResult = yield this._commandHandlers[command.$type].handle(command, execContext);
                return handlingResult;
            }
            else {
                execContext.logger.info({
                    location: logging_1.LoggerLocationFormatter.end(Dispatcher.$type, Dispatcher._commandMethodName),
                    message: `no handler found for command type: ${command.$type}`
                });
                throw new utilities_1.Exception('no-cmd-handler-registered');
            }
        });
    }
    registerQueryHandler(queryType, queryHandler) {
        this._queryHandlers[queryType] = queryHandler;
        return this;
    }
    handleQuery(query, execContext) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._queryHandlers[query.$type]) {
                const handlingResult = yield this._queryHandlers[query.$type].handle(query, execContext);
                return handlingResult;
            }
            else {
                execContext.logger.info({
                    location: logging_1.LoggerLocationFormatter.end(Dispatcher.$type, Dispatcher._queryMethodName),
                    message: `no handler found for query type: ${query.$type}`
                });
                throw new utilities_1.Exception('no-query-handler-registered');
            }
        });
    }
}
exports.Dispatcher = Dispatcher;
Dispatcher.$type = 'dispatcher';
Dispatcher._eventMethodName = 'handleEvent';
Dispatcher._commandMethodName = 'handleCommand';
Dispatcher._queryMethodName = 'handleQuery';
//# sourceMappingURL=dispatcher.js.map